<script>


export default {
    name: 'text-input',
    props: ['disabled', 'label', 'maxWidth', 'name', 'readonly', 'type', 'value'],
    methods: {
        onInputChange(...args) {
            // this.value = '';
            this.$emit('input', ...args);
        },
    },
};
</script>

<template>
    <div class="text-input field" :style="{ maxWidth }">
        <input
            :disabled="disabled"
            :name="name"
            placeholder=" "
            :readonly="readonly"
            :style="{ maxWidth }"
            :type="type"
            :value="value"
            @input="onInputChange"
        />
        <label :for="name">{{ label }}</label>
    </div>
</template>

<style lang="stylus">
@require "../styles/base.styl"
</style>
